// Jquery import "wrapper" to avoid issue with Bootstrap plugins.
import $ from 'jquery';

window.$ = $;
window.jQuery = $;
